__turbopack_context__.v({
  "chatSources": "i1CgdG_chatSources",
  "fadeInPop": "i1CgdG_fadeInPop",
  "smallishIcon": "i1CgdG_smallishIcon",
  "sourcesList": "i1CgdG_sourcesList",
  "sourcesListItem": "i1CgdG_sourcesListItem",
  "sourcesListItemAnchor": "i1CgdG_sourcesListItemAnchor",
  "sourcesListText": "i1CgdG_sourcesListText",
  "sourcesTitle": "i1CgdG_sourcesTitle",
});
